import { render, staticRenderFns } from "./RoleRegisterList.vue?vue&type=template&id=e5e2de1e&"
import script from "./RoleRegisterList.vue?vue&type=script&lang=ts&"
export * from "./RoleRegisterList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports